import { useParams, Link } from 'react-router-dom';
import { Bars } from 'react-loader-spinner';
import { Button } from 'react-bootstrap';
import { useMachineQueue } from '../../features/jobs/queues/hooks/useQueues.js';
import MachineQueueTable from '../../components/tables/MachineQueueTable.js';

function simulateExecution({ jobId, taskId }) {
  console.log('CLICKED ', jobId, taskId);
  // const res = await fetch(
  //   ,
  //   {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ jobId, taskId, tokenId })
  //   }
  // );

  // if (!res.ok) {
  //   const txt = await res.text().catch(() => '');
  //   throw new Error(`HTTP ${res.status} ${txt}`);
  // }
  // return res.json();
}

const MachineQueue = () => {
  const { machineId } = useParams();
  const mid = String(machineId || '').toLowerCase();

  const { data, isLoading, error } = useMachineQueue(mid);

  if (isLoading) {
    return (
      <Bars
        height="80"
        width="80"
        radius="9"
        color={'#3874ff'}
        ariaLabel="loading"
        wrapperStyle={styles.spinnerContainer}
      />
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <h4>Error</h4>
        <pre className="text-danger">{String(error?.message || error)}</pre>
      </div>
    );
  }

  const groups = data?.groups || [];
  const editPath = `/apps/machine-management/machine-queue/${mid}/edit`;

  return (
    <div className="mb-9 mt-0">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h2 className="mb-1">Machine Queue</h2>
          <div className="text-700">
            Machine: <b>{data?.machineId}</b> • Queue size:{' '}
            <b>{data?.queueSize ?? 0}</b>
          </div>
        </div>

        <div>
          <Button as={Link} to={editPath} variant="primary">
            Edit Queue
          </Button>
        </div>
      </div>

      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
        <MachineQueueTable
          machineId={data?.machineId}
          rows={groups}
          simulateExecution={simulateExecution}
        />
      </div>
    </div>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }
};

export default MachineQueue;
